import React, { useEffect } from 'react';
import { RxCross2 } from 'react-icons/rx';

interface ModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose?: () => void;
  showCloseButton?: boolean;
  allowImplicitClose?: boolean;
  maxWidthClass?: string;
}

const Modal: React.FC<ModalProps> = ({
  children,
  isOpen,
  onClose,
  showCloseButton = false,
  allowImplicitClose = true,
  maxWidthClass,
}) => {
  const handleClickOutside = (event: React.MouseEvent<HTMLDivElement>) => {
    if (allowImplicitClose && event.target === event.currentTarget) {
      onClose?.();
    }
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (allowImplicitClose && event.key === 'Escape') {
        onClose?.();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  if (!isOpen) {
    return null;
  }

  return (
    <div
      data-testid="modal-background"
      className="fixed inset-0 flex justify-center bg-black bg-opacity-50 z-[1200] overflow-y-auto py-8"
      onClick={handleClickOutside}
    >
      <div
        className={`bg-white rounded-xl shadow-lg relative w-full ${maxWidthClass || 'max-w-[432px]'} m-4 my-auto`}
      >
        {children}
        {showCloseButton && (
          <button
            onClick={onClose}
            className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
          >
            <RxCross2 className="w-6 h-6" />
          </button>
        )}
      </div>
    </div>
  );
};

export default Modal;
